export default __webpack_public_path__ + "static/media/word.4180ed6c.png";